/**
 * This function is copied from `octo-fish-internal-tools`
 * https://bitbucket.org/efishery/fish-internal-tool/src/master/frontend/src/libs/utils/*
 */
export const numberInputFormatter = (value: string) => {
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const capitalize = (s: string) => {
  return (s && s[0].toUpperCase() + s.slice(1)) || '';
};

export const capitalizeFirstLetter = (s: string) => {
  return (s && s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()) || '';
};

export const normalizeValue = (s: string) => {
  const value = s.replace(/_/g, ' ');
  return capitalizeFirstLetter(value);
};

export const unslug = (slug: string) => {
  const words = slug.split('-');

  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    words[i] = word.charAt(0).toUpperCase() + word.slice(1);
  }

  return words.join(' ');
};
